import React from 'react';
import { Select, DatePicker, Button, Table, message, ConfigProvider, Space } from 'antd';
import { APIService } from '../../../services/appraisement/api';
import reactDialog from '../../../lib/editableDialog';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { returnIframeUrl } from "../../../lib/http";
import { __waterDocumentSvg } from '../../../lib/waterMarking.js';
import { CalendarTimeService } from '../../../services/calendar/calendar.tool.service.js';
import Popup from '../Popup/Popup.jsx'
import zhCN from 'antd/es/locale/zh_CN';
import './Performance.scss'
import 'moment/locale/zh-cn';
import 'antd/dist/antd.css';
import moment from 'moment';
moment.locale('zh-cn'); // 国际化

const { RangePicker } = DatePicker;

class Performance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [], // 勾选中的下标
            loading: false,
            projectNumber: this.props.data.data.f6,
            listData: [],
            showSpin: true,
            IntervalType: "",
            startDate: "",
            DateClosed: "",

            demonstrate: false,
            pagination: {
                current: 1,
                pageSize: 15,
                // showSizeChanger: true,
                total: this.props.data.total,
            },
        }
    };

    componentDidMount() {
        this.getPerformance()

        const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
        __waterDocumentSvg({
            container: document.getElementById('Performance'),
            // content: `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
            content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
            width: '700px',
            height: '550px',
            opacity: '0.1',
            fontSize: '26px',
            zIndex: 1000
        })
    }

    // 点击勾选
    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys: selectedRowKeys });
    };

    BatchDownload = () => {
        let { listData, selectedRowKeys } = this.state

        console.log(selectedRowKeys, "selectedRowKeys")

        if (selectedRowKeys.length > 0) {
            let ids = []
            selectedRowKeys.map((item, index) => {
                ids.push(listData[item].file_id)
            })
            if (ids.length > 50) {
                message.error('当前下载条数超过50,请重新勾选');
                this.setState({ loading: false })
            } else {
                console.log(ids, "ids")

                let param = {
                    file_ids: JSON.stringify(ids),
                }

                let url = returnIframeUrl('/citic/bulk_batch_download_performance_report/', param);
                let aElement = document.createElement('a'); //创建节点
                document.body.appendChild(aElement);
                aElement.style.display = 'none';
                aElement.href = url;
                aElement.click();
                document.body.removeChild(aElement);

                this.setState({ loading: true });
                setTimeout(() => {
                    this.setState({
                        selectedRowKeys: [],
                        loading: false
                    });
                }, 1000);
            }
        } else {
            message.warning('请勾选需要下载数据');
        }

    }

    // 绩效查看列表
    getPerformance = () => {
        let { data } = this.props
        this.setState({ listData: data.listdata, showSpin: data.showSpin })
    }

    queryTime = () => {
        let { projectNumber, IntervalType, startDate, DateClosed ,pagination} = this.state;
        let { current, pageSize } = pagination;
        this.setState({ showSpin: true })

        let param = {
            first: Number(current - 1) * pageSize,
            rows: pageSize,
            project_number: projectNumber,
            project_interval_type: IntervalType,
            project_start_time: startDate,
            project_end_time: DateClosed,
        }

        APIService.performanceReportData(param).then(res => {
            if (res.success) {
                console.log(res, "绩效查看")
                this.setState({ 
                    listData: res.data, 
                    showSpin: false,
                    pagination:{
                        ...this.state.pagination,
                        total:res.total_number,
                    }
                 })
            } else {
                message.error(res.error);
            }
        }).catch(err => {
            console.log('项目列表接口 Error', err)
        })
    }

    // 绩效归因表查询下载接口
    exportExcel = (item, a) => {
        let param = {}

        if (a === 1) {
            param = {
                file_id: item.file_id,
                table_id:'724_D9Lm3xtei7mKqBb7ugC6TR',
            }

            let url = returnIframeUrl('/citic/bulk_download_performance_report/', param);
            let aElement = document.createElement('a'); //创建节点
            document.body.appendChild(aElement);
            aElement.style.display = 'none';
            aElement.href = url;
            aElement.click();
            document.body.removeChild(aElement);
        } else {
            let check = reactDialog;
            item.table_id = '724_D9Lm3xtei7mKqBb7ugC6TR'
            check.show({
                title: '绩效查看',
                iszoom: true,
                el: Popup,
                data: item,
                className: "Popup"
            })
        }
    };

    render() {
        const { loading, selectedRowKeys, listData, showSpin,pagination } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange
        };
        const hasSelected = selectedRowKeys.length > 0;

        const columns = [
            {
                title: "报告名称",
                align: "center",
                dataIndex: "name",
                width: 340,
                ellipsis: true,

            },
            {
                title: "区间类型",
                dataIndex: "section",
                align: "center",
                width: 150,
            },
            {
                title: "操作",
                align: "center",
                dataIndex: "address",
                width: 200,
            },
        ];

        const data = [];

        listData.map((item, index) => {
            data.push({
                key: index,
                name: item.project_name,
                section: item.project_type,
                address:
                    <Space>
                        <Button size="small" type="primary" onClick={() => { this.exportExcel(item, 0) }}>查看</Button>
                        <Button size="small" type="primary" onClick={() => { this.exportExcel(item, 1) }}>下载</Button>
                    </Space>,
            });
        })

        return (
            <ConfigProvider locale={zhCN}>
                <div id="Performance">
                    <div className="box">
                        <div className="batch-Download">
                            <Button
                                type="primary"
                                onClick={() => this.BatchDownload()}
                                // disabled={!hasSelected}
                                loading={loading}
                                style={{ color: "#fff" }}
                            >
                                批量下载
                            </Button>
                            <span className="pitch">
                                {hasSelected ? `已选中 ${selectedRowKeys.length} 条` : ""}
                            </span>
                        </div>
                        <div className="Inquire">
                            查询日期：
                                <RangePicker
                                locale={locale}
                                style={{ marginRight: "20px" }}
                                getPopupContainer={triggerNode => triggerNode.parentElement}
                                onChange={(a, e) => {
                                    this.setState({ startDate: e[0], DateClosed: e[1] })
                                }}
                            />
                            区间类型:
                            <Select
                                allowClear
                                style={{ width: "200px", margin: "10px" }}
                                onChange={(value) => {
                                    console.log(value, "value")
                                    this.setState({ IntervalType: value })
                                }}
                            >
                                <Option value="1">近一年</Option>
                                <Option value="3">近三年</Option>
                                <Option value="0">月度</Option>
                            </Select>
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({
                                        pagination:{
                                            ...this.state.pagination,
                                            current:1,
                                        }
                                    },()=> {
                                        this.queryTime();
                                    })
                                }}
                            >
                                查询
                            </Button>
                        </div>
                        <Table
                            key={`${data}`}
                            loading={showSpin}
                            className="Performance-Tab"
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={data}
                            size='small'
                            pagination={pagination} // 显示分页
                            onChange={(pagination, filters, sorter) => {
                                console.log(pagination,'pagination')
                                this.setState((prev,props)=> {
                                    return {
                                        pagination:{
                                            ...this.state.pagination,
                                            current:pagination.current,
                                            pageSize:pagination.pageSize
                                        }
                                    }
                                },()=> {
                                    this.queryTime()
                                })
                            }}
                            rowClassName={(record, index) => {
                                let className = 'dark-row';
                                if (index % 2 === 1) className = 'light-row';
                                return className;
                            }}
                            scroll={{
                                // y: 530
                            }}
                        />
                    </div>
                </div>
            </ConfigProvider>

        )
    }
}
export default Performance;


// WEBPACK FOOTER //
// app/components/customPage/Performance/Performance.jsx